import { Card, CardHeader, CardTitle, CardContent, CardDescription } from "@/components/ui/card"
import { Switch } from "@/components/ui/switch"
import { Rocket } from "lucide-react"
import { type AIMonitorConfig } from "@/types/config"

interface ModeSettingsProps {
  monitoringEnabled: boolean
  onUpdate: (config: Partial<AIMonitorConfig>) => void
  isLoading?: boolean
}

export function ModeSettings({
  monitoringEnabled,
  onUpdate,
  isLoading
}: ModeSettingsProps) {
  return (
    <div className="space-y-4">
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Rocket className="h-5 w-5 text-blue-500"/>
            Bill Monitoring
          </CardTitle>
          <CardDescription>
            Enable the system to automatically evaluate bills for monitoring
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="space-y-2">
            <div className="flex items-center space-x-2">
              <Switch
                  id="monitoring-switch"
                  checked={monitoringEnabled}
                  onCheckedChange={(checked) => onUpdate({MonitoringEnabled: checked})}
                  disabled={isLoading}
                  aria-labelledby="monitoring-switch-label"
              />
              <label
                  htmlFor="monitoring-switch"
                  id="monitoring-switch-label"
                  className="text-sm font-medium leading-none cursor-pointer"
              >
                Enable Bill Monitoring
              </label>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}